// @flow
import { SearchFilterItem } from 'components/atoms/searchFilterItem';
import { SearchInput } from 'components/molecules/searchInput';
import React, { useState } from 'react';
import type { SearchOption } from 'types/filter';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  title: string,
  options: Array<SearchOption>,
  values: Array<number>,
  onClick: (option: SearchOption) => void,
  isArtistSearch?: boolean,
};

export const SearchFilter = (props: Props) => {
  const { title, options, values, isArtistSearch } = props;
  let [searchTerm, setSearchTerm] = useState('');
  let [filteredOptions, setFilteredOptions] = useState(options);

  const filterOptions = (value: string) => {
    // added search for capital letters also
    const matches = options.filter(
      option =>
        option.title.includes(value) ||
        option.title.toUpperCase().includes(value) ||
        option.title.toLowerCase().includes(value)
    );
    setSearchTerm(value);
    setFilteredOptions(matches);
  };

  return (
    <div className={'search-filter filter'}>
      {isArtistSearch ? (
        <span className={'artist-filter-title'}>{title}</span>
      ) : (
        <h5 className={'filter-title'}>{title}</h5>
      )}
      <SearchInput
        value={searchTerm}
        placeholder={'Search by name'}
        onChange={filterOptions}
      />
      <div
        className={
          isArtistSearch
            ? 'artist search-filter-options filter-options'
            : 'search-filter-options filter-options'
        }
        style={title === 'Artist' ? { width: '100%' } : { width: '90%' }}
      >
        {filteredOptions.map(option => {
          return (
            <SearchFilterItem
              key={isArtistSearch ? option.artistId : option.id}
              title={option.title}
              subTitle={option.subTitle}
              imageUrl={option.imageUrl}
              isArtistSearch={isArtistSearch}
              onClick={() => props.onClick(option)}
              isActive={
                values.indexOf(isArtistSearch ? option.artistId : option.id) >
                -1
              }
            />
          );
        })}
        {filteredOptions.length === 0 && (
          <div className={'empty-search'}>
            <em>No matches</em>
          </div>
        )}
      </div>
    </div>
  );
};
